export const apiConfig = {
    local: {
        EU: {
            getTrackingDetails: "https://tw5090y595.execute-api.us-west-2.amazonaws.com/test/rttv-gettrackingdetails",
            getTrackingDetailsForSupplyChain: "https://widget-auth.eu-west-1.alpha.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        },
        US:{
            getTrackingDetails: "https://tw5090y595.execute-api.us-west-2.amazonaws.com/test/rttv-gettrackingdetails",
            getTrackingDetailsForSupplyChain: "https://widget-auth.us-west-2.alpha.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        }
    },
    beta: {
        EU: {
            getTrackingDetails: "https://widget-auth.eu-west-1.alpha.rttv.transportation.amazon.dev/getTrackingDetails",
            getTrackingDetailsForSupplyChain: "https://widget-auth.eu-west-1.alpha.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        },
        US:{
            getTrackingDetails: "https://widget-auth.us-west-2.alpha.rttv.transportation.amazon.dev/getTrackingDetails",
            getTrackingDetailsForSupplyChain: "https://widget-auth.us-west-2.alpha.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        }
    },
    gamma: {
        EU: {
            getTrackingDetails: "https://auth.api.eu-west-1.eu-gamma.rttv.transportation.amazon.dev/getTrackingDetails",
            getTrackingDetailsForSupplyChain: "https://auth.api.eu-west-1.eu-gamma.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        },
        US:{
            getTrackingDetails: "https://r9atwc2kld.execute-api.us-east-1.amazonaws.com/prod/getTrackingDetails",
            getTrackingDetailsForSupplyChain: "https://r9atwc2kld.execute-api.us-east-1.amazonaws.com/prod/getTrackingResponsesForSupplyChain"
        }
    },
    prod: {
        EU: {
            getTrackingDetails: "https://widget-auth.api.eu-west-1.eu-prod.rttv.transportation.amazon.dev/getTrackingDetails",
            getTrackingDetailsForSupplyChain: "https://widget-auth.api.eu-west-1.eu-prod.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        },
        US:{
            getTrackingDetails: "https://widget-auth.api.us-east-1.na-prod.rttv.transportation.amazon.dev/getTrackingDetails",
            getTrackingDetailsForSupplyChain: "https://widget-auth.api.us-east-1.na-prod.rttv.transportation.amazon.dev/getTrackingResponsesForSupplyChain"
        }
    }
};